
const getDefaultState = () => {
  return {
    searchKey: ''
  }
}

const state = getDefaultState()

const mutations = {
  SET_KEY: (state, key) => {
    state.searchKey = key
  }
}

const actions = {

  setkey({ commit }, key) {
    return new Promise((resolve, reject) => {
      commit('SET_KEY', key)
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

